import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

  constructor(
    private httpService: HttpService
  ) { }

  public createEmployee = (data: any): Promise<any> => this.httpService.post('api/employee', data).toPromise();
  public supervisrosEmployees = (): Promise<any> => this.httpService.get('api/employees/supervisors').toPromise();
  public updateCheckedOffline = (id: string, checkedOfflineEmployee: boolean): Promise<any> => this.httpService.put(`api/employee/checkedOffline/${id}`, { checkedOfflineEmployee }).toPromise();
  public updateCheckedOfflineAll = (checkedOfflineEmployee: boolean): Promise<any> => this.httpService.put(`api/employees/checkedOffline/all`, { checkedOfflineEmployee }).toPromise();
  public getEmployees = (): Promise<any> => this.httpService.get('api/employees/select').toPromise();
  public updateDefaultRole = (roleId: string): Promise<any> => this.httpService.put(`api/employee/defaultRole`, { roleId }).toPromise();

}
